import { LegalDoc } from "@/components/app/LegalDoc";
import { PRIVACY_POLICY } from "@/data/legal";

export default function PrivacyPolicy() {
  return (
    <LegalDoc
      title="Privacy Policy"
      body={PRIVACY_POLICY}
      testId="privacy-policy-page"
      otherLabel="Terms of Use"
      otherTo="/terms"
    />
  );
}
